/* ==========================================================================
   Rook UI Core — Bottom App Bar Controller
   Web Component: <rk-bottom-app-bar-element>
   ========================================================================== */

import { RkComponent } from '@rook/component';

class RkBottomAppBarElement extends RkComponent {
    static hydration = 'eager';

    setup() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'menubar');

        this.items = Array.from(this.querySelectorAll('[role="menuitem"]'));
        this.items.forEach((item, index) => {
            item.setAttribute('tabindex', index === 0 ? '0' : '-1');
        });

        this.delegate({
            'keydown': this.onKeyDown,
        });
    }

    onKeyDown(event) {
        const currentItem = document.activeElement;
        const currentIndex = this.items.indexOf(currentItem);
        if (currentIndex === -1) return;

        let nextIndex = currentIndex;

        switch (event.key) {
            case 'ArrowRight':
                event.preventDefault();
                nextIndex = (currentIndex + 1) % this.items.length;
                break;
            case 'ArrowLeft':
                event.preventDefault();
                nextIndex = (currentIndex - 1 + this.items.length) % this.items.length;
                break;
            case 'Home':
                event.preventDefault();
                nextIndex = 0;
                break;
            case 'End':
                event.preventDefault();
                nextIndex = this.items.length - 1;
                break;
            case 'ArrowUp':
                if (currentItem.hasAttribute('aria-haspopup')) {
                    event.preventDefault();
                    currentItem.click();
                }
                return;
            default:
                return;
        }

        this.items[currentIndex].setAttribute('tabindex', '-1');
        this.items[nextIndex].setAttribute('tabindex', '0');
        this.items[nextIndex].focus();
    }
}

if (!customElements.get('rk-bottom-app-bar-element')) {
    customElements.define('rk-bottom-app-bar-element', RkBottomAppBarElement);
}
